<template>
  <ul class="d-flex pl-0 mb-0 justify-content-center align-items-center paginate-links">
    <li class="left-arrow" :class="page === 1 && 'disabled'" @click="handlePagination('prev')">
      <a>◀</a>
    </li>
    <li
      v-for="(pageNumber, key) in displayedPages"
      :key="key"
      :class="page === pageNumber && 'active'"
      @click="handlePagination('current', pageNumber)"
    >
      <a>{{ pageNumber }}</a>
    </li>
    <li
      class="right-arrow"
      :class="page >= pages.length && 'disabled'"
      @click="handlePagination('next')"
    >
      <a>▶</a>
    </li>
  </ul>
</template>

<script>
import Vue from "vue";

export default {
  name: "Pagination",
  data() {
    return {
      page: 1,
      pages: [],
      scrollTime: 250,
      initialPosition: 0,
      additionalPages: 4,
      displayedPagesLength: 5
    };
  },
  watch: {
    displayedList: function() {
      this.setPages();
    },
    page: function() {
      this.handlePaginate();
    }
  },
  mounted: function() {
    this.setPages();
  },
  props: {
    displayedList: Array,
    perPage: Number,
    paginate: Function,
    scrollId: String
  },
  computed: {
    displayedPages: function() {
      let slicePages = this.pages.slice(
        this.initialPosition,
        this.page + this.additionalPages
      );

      if (
        this.pages.length > 5 &&
        slicePages.length < this.displayedPagesLength
      ) {
        const differencedLength = this.displayedPagesLength - slicePages.length;
        slicePages = this.pages.slice(
          this.initialPosition - differencedLength,
          this.page + this.additionalPages
        );
      }
      return slicePages;
    }
  },
  methods: {
    setPages() {
      let numberOfPages = Math.ceil(this.displayedList.length / this.perPage);
      let totalPages = [];
      for (let index = 1; index <= numberOfPages; index++) {
        totalPages.push(index);
      }

      this.pages = totalPages;
    },
    handlePagination(page, pageNumber = null) {
      if (page === "current") {
        this.page = pageNumber;
        if (this.pages.length <= this.displayedPagesLength) {
          this.additionalPages = 5;
        } else {
          this.initialPosition = pageNumber - 1;
        }
      } else if (page === "prev" && this.page !== 1) {
        this.page--;
        if (this.pages.length <= this.displayedPagesLength) {
          this.additionalPages++;
        } else {
          this.initialPosition--;
        }
      } else if (page === "next" && this.page < this.pages.length) {
        this.page++;
        if (this.pages.length <= this.displayedPagesLength) {
          this.additionalPages--;
        } else {
          this.initialPosition++;
        }
      }
    },
    handlePaginate() {
      this.$emit("paginate", this.displayedList, this.page);
      window.scrollTo(0, 0);
    }
  }
};
</script>

<style scoped>
ul.paginate-links {
  list-style: none;
  width: 100%;
}

ul.paginate-links > li {
  cursor: pointer;
  padding: 3px 12px;
  transition: background-color 0.3s;
  margin-left: 4px;
  margin-right: 4px;
}

ul.paginate-links > li > a {
  color : #000000 !important;
}

ul.paginate-links > li.active {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: #000000;
  color: white !important;
  border-radius: 15px;
  height: 30px;
  width: 30px;
}

ul.paginate-links > li.active > a {
  color: white !important;
}

ul.paginate-links > li.left-arrow,
ul.paginate-links > li.right-arrow {
  font-size: 1.5rem;
  color: #0696d7;
}

ul.paginate-links > li.disabled > a {
  color: #000000 !important;
  cursor: text;
}
</style>


// WEBPACK FOOTER //
// src/components/Pagination.vue